import * as filters from '@/filters';
import Vue from 'vue';

export default function() {
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
  });
}
